var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2608_6606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2364 9.54715C25.0654 9.67315 22.0462 11.2888 22.0462 14.8812C22.0462 19.0364 25.888 20.5064 26.0029 20.5428C25.9853 20.6324 25.3926 22.556 23.9774 24.516C22.7155 26.2408 21.3975 27.9628 19.3926 27.9628C17.3877 27.9628 16.8717 26.8568 14.5572 26.8568C12.3017 26.8568 11.4998 27.9992 9.66585 27.9992C7.83194 27.9992 6.55233 26.4032 5.08108 24.4432C3.3769 22.1416 2 18.566 2 15.1724C2 9.72915 5.72678 6.84235 9.39459 6.84235C11.3435 6.84235 12.9681 8.05755 14.1916 8.05755C15.3563 8.05755 17.1725 6.76955 19.3897 6.76955C20.23 6.76955 23.2491 6.84235 25.2364 9.54715ZM18.3371 4.46515C19.2541 3.43195 19.9027 1.99835 19.9027 0.564753C19.9027 0.365953 19.885 0.164353 19.8467 0.00195312C18.3548 0.0551531 16.5799 0.945553 15.5096 2.12435C14.6693 3.03155 13.885 4.46515 13.885 5.91835C13.885 6.13675 13.9233 6.35515 13.941 6.42515C14.0354 6.44195 14.1887 6.46155 14.342 6.46155C15.6806 6.46155 17.3641 5.61035 18.3371 4.46515Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2608_6606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.24d5865180a5f60f36c058e03d6ca692.svg";
export { ForwardRef as ReactComponent };